import { DocumentsTableFeature } from 'features';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { OrderSection } from 'modules/order/common/components';
import { Field, MAX_FILES } from 'modules/order/common/forms/orderForm';

import { useConfirmationDocumentSection } from './useConfirmationDocumentSection';

export const ConfirmationDocumentSection = () => {
  const { t } = useTranslation();

  const { isDisabledField, isRequiredField } = useConfirmationDocumentSection();

  const isEditable = useIsFormEditable();

  return (
    <OrderSection
      afterFields={
        <DocumentsTableFeature
          maxDocumentCount={MAX_FILES}
          name="confirmationDocument.files"
          title={t('order.sections.confirmationDocumentSection.table.title')}
        />
      }
      fields={[
        <Field.Text
          fullWidth
          disabled={!isEditable ? false : isDisabledField}
          label={t(
            'order.sections.confirmationDocumentSection.fields.contractNumber.label'
          )}
          name="confirmationDocument.contractNumber"
          placeholder={
            !isDisabledField
              ? t(
                  'order.sections.confirmationDocumentSection.fields.contractNumber.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredField}
        />,

        <Field.DatePicker
          fullWidth
          disabled={!isEditable ? false : isDisabledField}
          label={t(
            'order.sections.confirmationDocumentSection.fields.contractDate.label'
          )}
          name="confirmationDocument.contractDate"
          placeholder={
            !isDisabledField
              ? t(
                  'order.sections.confirmationDocumentSection.fields.contractDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredField}
        />,
      ]}
      title={t('order.sections.confirmationDocumentSection.title')}
    />
  );
};
